import gql from 'graphql-tag';

export const getApplicationsWithAccounts = gql`
  query {
    getApplicationsWithAccounts {
      applicationId
      name
      remark
      date
      apiKey
      apiKeyHash
      sdkKey
      configuration
      apiMasterKeyId
      sdkMasterKeyId
      minisitePushLimit
      apiLimit
      accounts {
        type
        username
        email
      }
      allowSMS
      allowEmail
      smsCount
      emailCount
    }
  }
`
